import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_URL_SERVER || 'http://localhost:8000/api/v1',
  headers: {
    Accept: 'application/json'
  },
  timeout: 15000
})

// Interceptor token
api.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  error => Promise.reject(error)
)

// Interceptor response
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('user')
    }

    return Promise.reject(error)
  }
)

/**
 * Helper: normalisasi path avatar menjadi URL lengkap.
 * Dipakai di layout, header, dan profile page.
 */
export function resolveAvatarUrl(path) {
  if (!path) return ''

  // Sudah URL lengkap (http/https/data/blob)
  if (/^(https?:|data:|blob:)/i.test(path)) {
    return path
  }

  const baseURL = api.defaults.baseURL || ''
  let origin = ''

  try {
    origin = new URL(baseURL).origin
  } catch {
    origin = baseURL.replace(/\/api(\/.*)?$/, '')
  }

  const normalized = path.replace(/^\/+/, '')

  if (normalized.startsWith('storage/')) {
    return `${origin}/${normalized}`
  }

  return `${origin}/storage/${normalized}`
}

export default api